import fetch from 'libs/fetchWithAuth';
import { apiUrl } from 'libs/apiUrl';
const _baseUrl = apiUrl('/api/ext/translation-memories');

class TranslationMemories {
	static getList(req) {
		return fetch(_baseUrl, {}, req);
	}

	static get(id, req) {
		return fetch(_baseUrl + '/' + id, {}, req);
	}

	static save(data, req) {
		let _url = _baseUrl;
		let _method = 'POST';

		if (data.id != '0') {
			_url = _baseUrl + '/' + data.id;
			_method = 'PUT';
		}

		return fetch(
			_url,
			{
				method: _method,
				body: JSON.stringify(data),
			},
			req
		);
	}

	static delete(data, req) {
		return fetch(
			_baseUrl + '/batchDelete',
			{
				method: 'POST',
				body: JSON.stringify(data),
			},
			req
		);
	}

	static purge(data, req) {
		return fetch(
			_baseUrl + '/purge',
			{
				method: 'POST',
				body: JSON.stringify(data),
			},
			req
		);
	}

	static countTerms(id, req) {
		return fetch(_baseUrl + '/count-terms/' + id, {}, req);
	}

	static getImportLogs(id, req) {
		return fetch(_baseUrl + '/' + id + '/importReports', {}, req);
	}

	static searchForTerm(data, req) {
		return fetch(
			_baseUrl + '/search-for-term',
			{
				method: 'POST',
				body: JSON.stringify(data),
			},
			req
		);
	}

	static filterParams(id, req) {
		return fetch(_baseUrl + '/' + id + '/filter-params', {}, req);
	}

	static getTerms(data, req) {
		return fetch(
			_baseUrl + '/get-terms',
			{
				method: 'POST',
				body: JSON.stringify(data),
			},
			req
		);
	}

	static getTermsForSearchReplace(data, req) {
		return fetch(
			_baseUrl + '/get-terms-for-search-replace',
			{
				method: 'POST',
				body: JSON.stringify(data),
			},
			req
		);
	}

	static searchList(data, req) {
		return fetch(
			_baseUrl + '/search-list',
			{
				method: 'POST',
				body: JSON.stringify(data),
			},
			req
		);
	}

	static linkToProject(data, req) {
		return fetch(
			_baseUrl + '/link-to-project',
			{
				method: 'POST',
				body: JSON.stringify(data),
			},
			req
		);
	}

	static deleteTerms(data, req) {
		return fetch(
			_baseUrl + '/delete-terms',
			{
				method: 'POST',
				body: JSON.stringify(data),
			},
			req
		);
	}

	static updateTerms(data, req) {
		return fetch(
			_baseUrl + '/update-terms',
			{
				method: 'POST',
				body: JSON.stringify(data),
			},
			req
		);
	}

	static downVoteSuggestion(data, req) {
		return fetch(
			_baseUrl + '/downvote-term',
			{
				method: 'POST',
				body: JSON.stringify(data),
			},
			req
		);
	}

	static getMatchedByClientAndLangs(data, req) {
		return fetch(
			_baseUrl + '/get-matching-client',
			{
				method: 'POST',
				body: JSON.stringify(data),
			},
			req
		);
	}

	static getAttachedTMsByTemplateId(templateId, req) {
		return fetch(
			_baseUrl + '/get-template-tms/' + templateId,
			{
				method: 'GET',
			},
			req
		);
	}

	static addNewLangs(data, req) {
		return fetch(
			_baseUrl + '/add-new-langs',
			{
				method: 'POST',
				body: JSON.stringify(data),
			},
			req
		);
	}

	static removeLangs(data, req) {
		return fetch(
			_baseUrl + '/remove-langs',
			{
				method: 'POST',
				body: JSON.stringify(data),
			},
			req
		);
	}

	static validateTMX(data, req) {
		return fetch(
			_baseUrl + '/validate-tmx',
			{
				method: 'POST',
				body: JSON.stringify(data),
			},
			req
		);
	}

	static replaceAll(data, req) {
		return fetch(
			_baseUrl + '/replace-all',
			{
				method: 'POST',
				body: JSON.stringify(data),
			},
			req
		);
	}

	static replaceOne(data, req) {
		return fetch(
			_baseUrl + '/replace-one',
			{
				method: 'POST',
				body: JSON.stringify(data),
			},
			req
		);
	}

	static analyseTMX(data, req) {
		return fetch(
			_baseUrl + '/analyse-tmx',
			{
				method: 'POST',
				body: JSON.stringify(data),
			},
			req
		);
	}

	static star(data, req) {
		return fetch(
			_baseUrl + '/update-star',
			{
				method: 'POST',
				body: JSON.stringify(data),
			},
			req
		);
	}

	static getLinkedToTask(taskID, req) {
		return fetch(_baseUrl + '/linked-to-task/' + taskID, {}, req);
	}

	static incrementEntryHits(data, req) {
		return fetch(
			_baseUrl + '/increment-entry-hits',
			{
				method: 'POST',
				body: JSON.stringify(data),
			},
			req
		);
	}

	static merge(data, req) {
		return fetch(
			_baseUrl + '/merge',
			{
				method: 'POST',
				body: JSON.stringify(data),
			},
			req
		);
	}

	static rename(data, req){
		return fetch(
			_baseUrl + '/rename',
			{
				method: 'PUT',
				body: JSON.stringify(data),
			},
			req
		);
	}

	static getDefaultThreshold(projectId, req) {
		return fetch(_baseUrl + '/get-config-threshold/' + projectId, {}, req);
	}
}

export default TranslationMemories;
